import { createFileRoute, redirect } from '@tanstack/react-router';

// The standalone Chatbot Simulator was merged into the AI Chatbot page (bot
// config + a floating customer simulator, one section). Redirect the old path.
export const Route = createFileRoute('/_dashboard/dashboard/chatbot')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/chatbot' });
  },
});
